export const ENDPOINT = {
  /* Authe & autho */
  API_LOGIN: '/auth/login',

  
  /* Master data */
  MASTER_PROVINCES: '/province',
  MASTER_DISTRICTS: '/district/province/{id}',
  MASTER_WARDS: '/ward/district/{id}',
  MASTER_ROLES: '/role',
  MASTER_USER_PROFILE: '/user/profile',
  MASTER_USER_ROLE: '/user/role',
  MASTER_UPLOAD_IMAGE: '/images',
  MASTER_STATISTIC: '/statistic',

  /* Prescription base */
  PHONEBUYS: '/customer-buy',
  PHONEBUY_DETAIL: '/customer-buy/{id}', 
  CREATE_PHONEBUY: '/customer-buy',
  UPDATE_PHONEBUY: '/customer-buy/{id}',
  PHONEBUY_SORT: '/sort-condition/customer-buy',
  PHONEBUY_SEARCH: '/search-condition/customer-buy',
  UPLOAD_PHONEBUY: '/customer-buy/excel-import',

  /* Notificatioin */
  PHONEFIXS: '/customer-fix',
  PHONEFIX_DETAIL: '/customer-fix/{id}', 
  CREATE_PHONEFIX: '/customer-fix',
  UPDATE_PHONEFIX: '/customer-fix/{id}',
  PHONEFIX_SORT: '/sort-condition/customer-fix',
  PHONEFIX_SEARCH: '/search-condition/customer-fix',
  UPLOAD_PHONEFIX: '/customer-fix/excel-import',

  /* User */
  USERS: '/user',
  USER_DETAIL: '/user/{id}',
  USER_UPDATE: '/user/{id}',
  USER_CREATE: '/user',
  UPLOAD_USER_IMAGE: '/user/profile/upload',
  USER_UPDATE_PROFILE: '/user/profile',
  USER_UPDATE_PROFILE_ADMIN: '/user/profile-admin/{id}',
  USER_CONDITION_ORDER: '/search-condition/order/user',
  USER_CONDITION_SEARCH_STATUS: '/sort-condition/user',
  USER_UPDATE_PASSWORD: '/user/password',
  USER_UPDATE_PASSWORD_ADMIN: '/user/update-password/{id}',

  /* Prescription no auth */
  SETTING_DETAIL: '/setting',
  SETTING_UPDATE: '/setting',
}
